let isChrome = /chrome/gi.test(window.navigator.userAgent);

function getRangeClientRectsChrome(range) {
	let tempRange = range.cloneRange();
	let clientRects = [];

	for (let ancestor = range.endContainer; ancestor !== null; ancestor = ancestor.parentNode) {
		// If we've climbed up to the common ancestor, we can now use the
		// original start point and stop climbing the tree.
		let atCommonAncestor = ancestor === range.commonAncestorContainer;
		if (atCommonAncestor) {
			tempRange.setStart(range.startContainer, range.startOffset);
		} else {
			tempRange.setStart(tempRange.endContainer, 0);
		}
		let rects = Array.from(tempRange.getClientRects());
		clientRects.push(rects);
		if (atCommonAncestor) {
			let _ref;

			clientRects.reverse();
			return (_ref = []).concat.apply(_ref, clientRects);
		}
		tempRange.setEndBefore(ancestor);
	}
}

let getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
	return Array.from(range.getClientRects());
};

const getRangeBoundingClientRect = (range) => {
	// "Return a DOMRect object describing the smallest rectangle that includes
	// the first rectangle in list and all of the remaining rectangles of which
	// the height or width is not zero."
	// http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
	const rects = getRangeClientRects(range);
	let top = 0;
	let right = 0;
	let bottom = 0;
	let left = 0;

	if (rects.length) {
		// If the first rectangle has 0 width, use the second one, 
		// because Chrome renders a 0 width rectangle when the selection contains
		// a line break.
		if (rects.length > 1 && rects[0].width === 0) {
			let rect$1 = rects[1];
			top = rect$1.top;
			right = rect$1.right;
			bottom = rect$1.bottom;
			left = rect$1.left;
		} else {
			let rect$2 = rects[0];
			top = rect$2.top;
			right = rect$2.right;
			bottom = rect$2.bottom;
			left = rect$2.left;
		}

		for (let ii = 1; ii < rects.length; ii++) {
			let rect = rects[ii];
			if (rect.height !== 0 && rect.width !== 0) {
				top = Math.min(top, rect.top);
				right = Math.max(right, rect.right);
				bottom = Math.max(bottom, rect.bottom);
				left = Math.min(left, rect.left);
			}
		}
	}

	return {
		top: top,
		right: right,
		bottom: bottom,
		left: left,
		width: right - left,
		height: bottom - top,
	};
};

const getCaretOffset = (element) => {
	const caret = {
		start: 0,
		end: 0,
		text: '',
	};
	const doc = element.ownerDocument || element.document;
	const win = doc.defaultView || doc.parentWindow;
	let sel;
	if (typeof win.getSelection !== "undefined") {
		sel = win.getSelection();
		if (sel.rangeCount > 0) {
			const range = win.getSelection().getRangeAt(0);

			const startCaretRange = range.cloneRange();
			startCaretRange.selectNodeContents(element);
			startCaretRange.setEnd(range.startContainer, range.startOffset);
			caret.start = startCaretRange.toString().length;

			const preCaretRange = range.cloneRange();
			preCaretRange.selectNodeContents(element);
			preCaretRange.setEnd(range.endContainer, range.endOffset);
			caret.end = preCaretRange.toString().length;
		}
	} 
	// else if ((sel = doc.selection) && sel.type !== "Control") {
	//     const textRange = sel.createRange();
	//     const preCaretTextRange = doc.body.createTextRange();
	//     preCaretTextRange.moveToElementText(element);
	//     preCaretTextRange.setEndPoint("EndToEnd", textRange);
	//     caret.end = preCaretTextRange.text.length;
	// }
	if (sel.rangeCount > 0) {
		const range = sel.getRangeAt(0);
		caret.boundingRect = getRangeBoundingClientRect(range);
	}

	// eslint-ignore-next-line
	caret.text = sel.toString().replace(/(\r\n|\n|\r)/gm,"");
	return caret;
};
export default getCaretOffset;